import bobtailAPI from '../axiosConfig'
import Entity from './entity'

const ReserveAccount = new Entity('reserveaccount')

ReserveAccount.getClientReserves = async (params) => {
  return (await bobtailAPI()).get(ReserveAccount.baseUrl, {
    params,
  })
}

ReserveAccount.postReserveAccount = async (payload) => {
  return (await bobtailAPI()).post(ReserveAccount.baseUrl, {
    ...payload,
  })
}

export default ReserveAccount
